<template>
	<div class="wrapper">
		<top-bar/>
		<side-bar :disabledOptions="showNoData"/>
		<template v-show="!showNoData">
			<transition  name="fade" mode="out-in">
				<router-view @click="toggleMenu"/>
			</transition>
		</template>
		<no-data v-if="showNoData"/>
	</div>
</template>

<script>
export default {
	computed: {
		showNoData () {
			return this.$store.state.ui.showNoData;
		}
	},
	methods: {
		toggleMenu () {
			this.$store.dispatch('toggleMenu');
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/school/School.vue